import { connect } from 'react-redux';
import { globalKey } from 'data/sharedKeys';
import {
  loadLicenses, saveLicense, postLicenseReset, loadSingleLicense, editLicense
} from 'data/licenses/licenses.actions';
import { loadAccount } from 'data/accounts/accounts.actions';
import LicensePanelContainer from './LicensePanelContainer';

const key = Symbol('LicensePanel');
const actions = {
  loadLicenses: () => loadLicenses(key),
  loadSingleLicense: id => loadSingleLicense(key, id),
  saveLicense: license => saveLicense(license, key),
  postLicenseReset: () => postLicenseReset(key),
  editLicense: (license, id) => editLicense(license, id, key),
  loadAccount: () => loadAccount(globalKey)
};

function mapStateToProps(state) {
  return {
    ...state.licenses[key],
    account: { ...state.accounts[globalKey] }
  };
}

export default connect(mapStateToProps, actions)(LicensePanelContainer);
